<template>
  <div class="main-container">
    <!-- 商品 -->
    <div v-for="(type, index) in productDatas" :key="index" class="type-item">
      <img :src="type.titleImg" width="437px" :style="type.titleImgStyle">
      <div class="type-title" v-html="type.title"></div>
      <!-- <div :class="type.bgClass" > -->
        <div v-for="category in type.categorys" :key="category.desc" class="category-container" :class="category.bgClass" :style="{marginBottom: category.mb}">
          <div class="desc" :style="category.descStyle">{{ category.desc }}</div>
          <div class="product-list">
            <div v-for="pro in category.products" :key="pro.src" class="product-container display_flex justify-content_flex-justify" :class="pro.isNoMb?'mb-0':''" @click="toProductDetail(pro.type, pro.id)">
              <div class="productImg" :style="{backgroundImage: `url(${pro.img})`, backgroundSize: pro.bgSize, backgroundPosition: pro.bgPosition}">
                <img v-for="(tag, index) in pro.tags" :key="index" :src="tag.src" :class="tag.class">
              </div>
              <div class="product-text-box display_flex justify-content_flex-justify flex-direction_column flex_1">
                <div class="name" v-html="pro.name"></div>
                <div>
                  <div class="tips-box">{{ pro.tips }}</div>
                  <div class="address">品牌所在地：{{ pro.address }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      <!-- </div> -->
    </div>
    <!-- 功效图 -->
    <div v-for="item in bottomImgs" :key="item.src" :style="{marginTop: item.mt}">
      <img :src="item.src" :style="item.imgStyle" alt="">
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/assets/css/mixin.scss";
div {
  box-sizing: border-box;
}

.mb-0 {
  margin-bottom: 0!important;
}

.desc {
  width: 940px;
  padding-left: 24px;
  margin-bottom: 20px;
  text-align: left;
  font-size: 24px;
  font-weight: 400;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 50px;
  letter-spacing: 3px;
}

.main-container {
  box-sizing: border-box;
  // max-width: 1920px;
  height: 9000px;
  padding-top: 809px;
  margin: 100px auto 0;
  background: url('https://p1.fishqc.net/Fu8_q1JwWxerBd5ZLi5stkrdZdOP') center center no-repeat;
  background-size: cover;
  color: #252525;
  font-weight: 400;
}

.type-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.type-title {
  font-size: 30px;
  font-family: PingFangSC-Regular, PingFang SC;
  line-height: 50px;
}

.category-container {
  
}

.category-bg_1 {
  width: 1028px;
  height: 1401px;
  padding: 241px 0 0 55px;
  margin-top: -39px;
  background: url('http://p1.fishqc.net/FnQN9SuQnGCFy3abSGVydbdTqDfx') center center no-repeat;
  background-size: contain;
}

.category-bg_2 {
  width: 1052px;
  height: 833px;
  padding: 198px 0 0 20px;
  margin-left: 90px;
  background: url('http://p1.fishqc.net/Fpa8ryTtnnjt-M8Ll19oQ86PMVbk') center center no-repeat;
  background-size: contain;
}

.category-bg_3 {
  width: 1011px;
  height: 858px;
  padding: 221px 0 0 36px;
  margin-left: 10px;
  background: url('http://p1.fishqc.net/FmbJKNNzeLsV1kZkYJk8q-LquTTd') center center no-repeat;
  background-size: contain;
}

.category-bg_4 {
  width: 1055px;
  height: 836px;
  padding: 221px 0 0 20px;
  margin-left: 90px;
  background: url('http://p1.fishqc.net/Fmb4QF_LaCeKb-Bdxq9oxXJHhKJY') center center no-repeat;
  background-size: contain;
}

.product-list {
  display: flex;
  flex-wrap: wrap;
  width: 1012px;
}

.product-container {
  width: 464px;
  height: 226px;
  padding: 12px 0 10px 12px;
  margin-bottom: 35px;
  background: #FFC5D7;
  border-radius: 8px;
  cursor: pointer;

  &:nth-child(odd) {
    margin-right: 25px
  }
}

.productImg {
  position: relative;
  width: 174px;
  // height: 197px;
  border-radius: 8px;
  background-color: #fff;
  background-position: center center;
  background-size: contain;
  background-repeat: no-repeat;

  img {
    position: absolute;
    width: 80px;
    height: 80px;
    bottom: 0px;
  }
}

.green-icon{
  right: -8px;
}

.effect-icon_1 {
  right: -8px;
}

.effect-icon_2 {
  width: 70px!important;
  height: 70px!important;
  right: 44px;
}

.effect-icon_3 {
  width: 70px!important;
  height: 70px!important;
  right: -8px;
}

.product-text-box {
  padding-bottom: 13px;
  margin-left: 20px;
  font-size: 18px;
  text-align: left;

  .name {
    font-size: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 33px;
  }

  .tips-box {
    width: 99px;
    height: 30px;
    margin-bottom: 15px;
    color: #fff;
    background: #5956FF;
    border-radius: 16px;
    text-align: center;
    line-height: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
  }

  .address { 
    font-weight: 500;
    font-family: PingFangSC-Medium, PingFang SC;
  }
}

</style>
<script>
import { myMixin } from '@/mixin/mixin.js'

let greenIconUrl = 'https://p1.fishqc.net/FsSAn-Hj02ROZMg-VwKL3MUXat5I'

export default {
  name: '2023-1111',
  mixins: [myMixin],
  data() {
    return {
      // greenIconUrl,
      productDatas: [
        {
          title: '双十一，护肤黄金组合登场！精华<br/>和乳液，为你的肌肤提供双重滋养和保湿，<br/>感受皮肤的焕发！',
          titleImg: 'http://p1.fishqc.net/FnZ6Y-TAelRmojU6_mknTUlBzYu1',
          titleImgStyle: 'margin-bottom: 32px',
          categorys: [
            {
              desc: '护肤界明星产品精华，不仅能改善肤质，还能提供额外的保湿和滋养，使皮肤更加健康和年轻。',
              bgClass: 'category-bg_1',
              mb: '0px',
              products: [
                {
                  img: 'http://p1.fishqc.net/Ftc1gs8sTkmhBXmP59IjVNRZDUls',
                  name: 'HELENA RUBINSTEIN<br>赫莲娜<br>绿宝瓶强韧修护精华露',
                  address: '法国',
                  tips: '重塑屏障',
                  type: 'cosmetic',
                  id: 'Dso7hCiX3Ui4DtL4ek3MLA',
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ]
                },
                {
                  img: 'http://p1.fishqc.net/Fml-hEcTQncUT9RD2YXu2PgL-cKe',
                  name: 'PURID朴理<br>创研修护焕漾精华液<br>（2号精华）',
                  address: '中国',
                  tips: '抗红御氧',
                  type: 'cosmetic',
                  id: 'uBKKOZ0Ao5UKRKyj9CEC6g',
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ]
                },
                {
                  img: 'http://p1.fishqc.net/Fm4aZyq7_DuO8CDr51oKnz8pEQIq',
                  name: 'SKINCEUTICALS修丽可<br>植萃舒缓亮妍精华露',
                  tips: '舒缓褪红',
                  address: '美国',
                  type: 'cosmetic',
                  id: 'DdB7MXBnpsfWJUxHJ23liQ',
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ]
                },
                {
                  img: 'http://p1.fishqc.net/Foqm68GT8xsxzi3DdDTduvF_3Jzo',
                  name: "MyClorisland花哲蔻<br>菁纯牡丹凝时鲜颜精萃油",
                  tips: '抗皱淡纹',
                  address: '中国',
                  type: 'cosmetic',
                  id: 'OhzLUW1lfwnrl7_LE2Y3aA',
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ]
                },
                {
                  img: 'https://p1.fishqc.net/FpotQ0JicZLT9zPjjDAGTId13NhG',
                  name: "KIEHL'S科颜氏<br>集焕白均衡亮肤淡斑精华液",
                  tips: '白皙淡印',
                  address: '美国',
                  type: 'cosmetic',
                  id: 'MD_L6OxxcHLVZXrQPsfTMQ',
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ]
                },
                {
                  img: 'http://p1.fishqc.net/FrPfvmxtjx3lJdFxFLP1029YuJv1',
                  name: "GRASUS瑰倚丝<br>果萃柔肤精华液",
                  tips: '软化角质',
                  address: '中国',
                  type: 'cosmetic',
                  id: 'g9RkjEhY_8FoisLx5_PO4Q',
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ]
                },
                {
                  img: 'http://p1.fishqc.net/FkoRkS9IwXQQ5B9pJKPUivnMkvjM',
                  name: "COSME DECORTE黛珂<br>莹润粹白璇亮菁华液",
                  tips: '焕亮嫩肤',
                  address: '日本',
                  type: 'cosmetic',
                  id: 'h5LBDZFWWgR7W287E052Wg',
                  isNoMb: true,
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ]
                },
                {
                  img: 'http://p1.fishqc.net/FumhG3kUXJVIOiicfZI8gFDzSfDx',
                  name: "GÈNECHER简莳<br>蕴能时光精华液",
                  tips: '深层透润',
                  address: '中国',
                  type: 'cosmetic',
                  id: '7zZQd88A_7LZdaXSQtFQ2Q',
                  isNoMb: true,
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ]
                }
              ]
            },
            {
              desc: '乳液不仅是滋润，更是皮肤的屏障，保护肌肤免受外部伤害。选择合适的乳液，让肌肤持续保持水润，焕发活力。',
              bgClass: 'category-bg_2',
              mb: '0px',
              products: [
                {
                  img: 'http://p1.fishqc.net/FhVPQ-y1itCUnm48uX222tvO1GHJ',
                  name: '善草纪<br>茉莉滢润保湿精华乳',
                  address: '中国',
                  tips: '长效保湿',
                  type: 'cosmetic',
                  id: 'unISAIvq50vJuofQsWi1ZA',
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ]
                },
                {
                  img: 'http://p1.fishqc.net/Fn0vkAHuvu0P76AtgDIONkzBr1Ey',
                  name: 'EAU THERMALE AVENE<br>雅漾<br>高效抗敏舒缓保湿乳',
                  tips: '舒缓维稳',
                  address: '法国',
                  type: 'cosmetic',
                  id: 'vawwnwDwvEzAbIO1K5uG-g',
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ]
                },
                {
                  img: 'http://p1.fishqc.net/FsjAsUJyGrGGlkqXx0MpwzlBTdI4',
                  name: 'MUJI无印良品<br>基础润肤乳液 高保湿型',
                  tips: '水润光滑',
                  address: '日本',
                  type: 'cosmetic',
                  id: 'igxZpnpfFnfefQrVXtU5Yw',
                  isNoMb: true,
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ]
                },
                {
                  img: 'http://p1.fishqc.net/FnIpXE0cDNmvepS-FtiBmmnt05zT',
                  name: 'ALBION奥碧虹<br>奥尔滨清新焕白渗透乳<br>(保湿型)',
                  tips: '滋养弹润',
                  address: '日本',
                  type: 'cosmetic',
                  id: 'MmKWkluKBfcDQLGmMa9gpw',
                  isNoMb: true,
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ]
                }
              ]
            },
          ],
        },
        { 
          title: '双十一不仅关乎美丽，还关乎健康。身体护理及保<br>健品为你的身体提供科学精心挑选的呵护。',
          titleImg: 'http://p1.fishqc.net/Fh4-sqgncWurbPDQ8YeotcS7vCT2',
          titleImgStyle: 'margin: 69px 0 47px',
          categorys: [
            {
              desc: '身体乳是全身肌肤的密友。它能滋润、保湿，同时改善肤质，为身体肌肤提供全面护理。',
              descStyle: 'padding-left: 32px',
              bgClass: 'category-bg_3',
              mb: '0px',
              products: [
                {
                  img: 'http://p1.fishqc.net/FhivBx70mixcsmhae-56jaq44bZY',
                  name: 'BATHFEEL浴见<br>凝润修护身体油霜',
                  tips: '修护润泽',
                  address: '中国',
                  type: 'cosmetic',
                  id: 'wVK3of0LYk1dqrU-bmkCSg',
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ]
                },
                {
                  img: 'http://p1.fishqc.net/FrsSCI1k8VKDO4f4jnLDr3QiW-Qf',
                  name: "NIVEA妮维雅<br>精华油润肤露 - 樱花香气",
                  tips: '轻薄温润',
                  address: '德国',
                  type: 'cosmetic',
                  id: 'mMZFtafUdgvl4RmhzfP3xw',
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ],
                  isNoMb: true
                },
                {
                  img: 'http://p1.fishqc.net/FkL1cqz99_uaW7Nyue6EwReyFyul',
                  name: "CeraVe<br>长效保湿修复乳",
                  tips: '保湿抗炎',
                  address: '法国',
                  type: 'cosmetic',
                  id: 'G8DSWGQVu9-PBfLpFkvDiA',
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ],
                  isNoMb: true
                },
                {
                  img: 'http://p1.fishqc.net/Fu6jvhBVYgiadTjI8NgRsghnHmwB',
                  name: "SEBAMED施巴<br>保湿润肤露",
                  tips: '深层滋润',
                  address: '德国',
                  type: 'cosmetic',
                  id: 'XIH3TwOiX5vjlKcNH19j-w',
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ],
                  isNoMb: true
                }
              ]
            },
            {
              desc: '保健品是对身体的投资，不仅可以弥补日常饮食不足，还能为身体提供额外支持，让健康处于最佳状态。',
              descStyle: 'padding-left: 30px',
              bgClass: 'category-bg_4',
              mb: '0px',
              products: [
                {
                  img: 'http://p1.fishqc.net/FoQGY6Rt-ouIkNVf5L-2aQz2qCKh',
                  name: 'Doppelherz双心<br>高端护眼宝',
                  tips: '双效润眼',
                  address: '德国',
                  type: 'food',
                  id: 'nwP2iMHEcCWxDuo8IqCNow',
                  tags: [
                  { src: 'https://p1.fishqc.net/FmF41xyiXcX2EqM3wfhYzs2teVzU', class: 'effect-icon_2' },
                  { src: 'https://p1.fishqc.net/Fh2fRUfXmeUElQcmPqJ_FCbqxbqL', class: 'effect-icon_3' }
                  ]
                },
                {
                  img: 'http://p1.fishqc.net/Fi1w8yi5SkLrPEx7Fwhz04Fu7FMC',
                  name: 'FANCL芳珂<br>透亮美肌营养素(片剂)',
                  tips: '亮白光泽',
                  address: '日本',
                  type: 'food',
                  id: '0QT86UqXRI8JN_MhuSjT3Q',
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ]
                },
                {
                  img: 'http://p1.fishqc.net/FvrkUQsX14A8xUkxnEWYfSQP9XTV',
                  name: 'SWISSE ULTIBOOST<br>无腥味野生鱼油',
                  tips: '呵护健康',
                  address: '澳大利亚',
                  type: 'food',
                  id: 'MHyOQg1J2NFlohf7kP2goQ',
                  isNoMb: true,
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ]
                },
                {
                  img: 'http://p1.fishqc.net/FmH4OF0u85W8j__A1zE1cPsNoxTJ',
                  name: 'GNC健安喜<br>高含量钙片1000mg',
                  tips: '富含高钙',
                  address: '美国',
                  type: 'food',
                  id: 'yIO8Zliupd7oMIl6hXA_yg',
                  isNoMb: true,
                  tags: [
                    { src: greenIconUrl, class: 'green-icon' }
                  ]
                }
              ]
            },
          ],
        }
      ],
      bottomImgs: [
        {
          src: 'http://p1.fishqc.net/Fn0wpZ3nDS-N3gg6IiWJMCLFDkhi',
          mt: '77px',
          imgStyle: 'width: 546px; height: 60px'
        },
        {
          src: 'http://p1.fishqc.net/FkZ1ceN5OjBUU7Uyz7rAue17d4cy',
          mt: '40px',
          imgStyle: 'width: 989px; height: 1245px'
        },
        {
          src: 'http://p1.fishqc.net/FolX8I2nS4mphT-rp__ZxdjY9Ij1',
          mt: '74px',
          imgStyle: 'width: 437px; height: 63px'
        },
        {
          src: 'http://p1.fishqc.net/FnSHEU4KXyhq2gM9go1Y5uzHL4Sd',
          mt: '45px',
          imgStyle: 'width: 991px; height: 858px'
        },
        {
          src: 'http://p1.fishqc.net/FhSVZEgTkPXZEGu2He1QkwhGKhBA',
          mt: '60px',
          imgStyle: 'width: 991px; height: 758px'
        },
        {
          src: 'http://p1.fishqc.net/Fi0JfnCU5j7VkBtKkEGrd1NZN-Pb',
          // src: 'https://p1.fishqc.net/FozCNnjpwBvXj2qCGLH72pLNLKc8',
          mt: '105px',
          imgStyle: 'width: 696px; height: 205px'
        },
      ]
    }

  },
  computed: {
    swiper() {
      return this.$refs.order_report_Swiper.$swiper
    }
  },
  mounted() {
    // var position  =  this.$route.query.position
    // this.scrollTo(position)
    this.currentlang = window.localStorage.getItem("LOCALE") || 'chs'
  },
  methods: {
    scrollTo(position) {
      var that = this;
      var scroll_H;
      this.$nextTick(function () {
        if (position == 'greenrank') {
          var d = document.getElementById("greenrank");
          var topPos = d.offsetTop;
          scroll_H = topPos - 110; //减去header高度
        } else {
          scroll_H = this.$refs[position].offsetTop - 110; //减去header高度
        }
        //全局方法
        that.scrollToY(scroll_H, 1500, 'easeInOutQuint');
      })
    },
    toProductDetail(type, prdid) {
      this.$router.push({
        path: '/product/' + type + '/' + prdid
      })

    }
  }
}
</script>